/**
 * @fileoverview Custom hook for processing ad platform spend data from aggregated platform breakdown.
 * @module shared/hooks/useAdPlatformSpend
 */

import { useAdPlatformBreakdown } from '@/shared/hooks/dashboard/useAdPlatformBreakdown'

/**
 * Ad platform spend data structure
 */
export interface AdPlatformSpendData {
  /** Platform name */
  platform: string
  /** Spend amount */
  amount: number
  /** Percentage of total ad spend */
  percentage: number
}

/**
 * Hook return type
 */
interface UseAdPlatformSpendReturn {
  /** Array of platform spend data or empty array if not available */
  data: AdPlatformSpendData[]
  /** Total ad spend across all platforms */
  totalSpend: number
  /** Loading state indicator */
  isLoading: boolean
  /** Error message if processing failed */
  error: string | null
}

/**
 * Custom hook for processing ad platform spend data.
 * Returns per-platform breakdown data aggregated from ecommerce statistics.
 */
export function useAdPlatformSpend(): UseAdPlatformSpendReturn {
  const { data, totalSpend, isLoading, error } = useAdPlatformBreakdown()

  return {
    data,
    totalSpend,
    isLoading,
    error,
  }
}
